<!--=========================
=            APP            =
==========================-->
<template>
  <v-app>
    <app-layout></app-layout>
  </v-app>
</template>
<script>
import AppLayout from "./layout/AppLayout.vue";

export default {
  name: "App",

  components: {
    AppLayout
  },

  data: () => ({
    isMobile: false
  }),
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, {
        passive: true
      });
    }
  },

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, {
      passive: true
    });
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 600;
    }
  }
};
</script>

<!--====  End of APP  ====-->